export default __webpack_public_path__ + "static/media/bg_actualites.952a548c.jpg";